import React from 'react';

import { useSelector } from 'hooks';
import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { getSelectedSelfServiceId } from 'modules/auth/selectors';
import { useUpdateAdditionalCustomerMutation } from 'modules/selfServices/service';
import { CustomerInfo as CustomerInfoType } from 'modules/selfServices/types/CustomerInfo';

import Content from 'components/CustomerInfo/Content';
import ConnectedForm from 'components/ui/ConnectedForm';

const AdditionalCustomerInfo: React.FC<PageBaseProps> = ({ onNext, onPrev, ...pageProps }) => {
  const selfServiceId = useSelector(getSelectedSelfServiceId) as string;
  const [updateAdditionalCustomer, { isLoading }] = useUpdateAdditionalCustomerMutation();

  const handleSubmit = React.useCallback(async (values: CustomerInfoType & { permanent?: string }) => {
    const { permanent: _, ...formData } = values;
    try {
      await updateAdditionalCustomer({ id: selfServiceId, body: formData }).unwrap();
      onNext?.();
    } catch {}
  }, [onNext, selfServiceId, updateAdditionalCustomer]);

  return (
    <ConnectedForm
      onNext={onNext}
      component={Content}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      formKey={FormKeys.ADDITIONAL_CUSTOMER_INFO}
      isAdditionalCustomer
      isPhoneNumberOrEmailMandatory
      subscription={{ pristine: true, errors: true }}
      onPrev={onPrev}
      {...pageProps}
    />
  );
};

export default AdditionalCustomerInfo;
